import Axios from "axios";

export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const API_KEY= process.env.REACT_APP_API_KEY;

const api = Axios.create({
    baseURL: API_ENDPOINT,
    timeout: 100000,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
    },
});

api.interceptors.response.use(resp => {
    return resp;
}, error => {
    if(error.response.status === 401) {
        window.location.href = '/Login';
    }

    if(error.response.status === 403) {
        window.location.href = '/Forbidden';
    }
})

export const clear = function (){
    delete api.defaults.headers.common['Authorization'];
    localStorage.removeItem('accessInfo');
    localStorage.removeItem('token');
}

export const setAccessToken = () => {
    const authorizationToken = `Bearer ${JSON.parse(localStorage.getItem('accessInfo'))?.accessToken}`
    //api.defaults .headers.common['Authorization'] = authorizationToken;
    return authorizationToken;
}

export default api;
